export default __webpack_public_path__ + "static/media/ggb-background.564b1875.svg";